export default __webpack_public_path__ + "static/media/Level33.a07c3835.svg";